import React from 'react'
import { Box, Container } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { ForgotPasswordForm } from '../components/Auth/ForgotPasswordForm'
import { PublicRoute } from '../components/Auth/ProtectedRoute'

export const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate()

  const handleBackToLogin = () => {
    navigate('/login')
  }

  return (
    <PublicRoute>
      <Box minH="100vh" bg="gray.50" py={8}>
        <Container maxW="container.sm">
          <ForgotPasswordForm onBackToLogin={handleBackToLogin} />
        </Container>
      </Box>
    </PublicRoute>
  )
}

export default ForgotPasswordPage 